var React = require('react');

function IconLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M381.6 511l379.7-341.6c2.2-2 3.5-4.8 3.5-7.7V73c0-8.8-10.4-13.6-17.1-7.7L258.8 502.6c-4.7 4.1-4.7 11.4 0 15.5l488.9 438.3c6.6 5.8 17.1 1.1 17.1-7.7v-87.6c0-3-1.3-5.8-3.5-7.7L381.6 511z"}));
}

IconLeft.displayName = "IconLeft";

IconLeft.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconLeft;

IconLeft.default = IconLeft;
